module.exports = __webpack_public_path__ + "static/media/hero-1.0e8b2be5.jpg";